import React, { useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import AuthContext from '../../../contexes/AuthContext';
import { appendEmbedParam, getEmbedHomePath } from '../../../helpers/embedMode';
import { hasPartnerSession } from '../../../services/partnerSession';
import Loading from '../Loading/Loading';
import { canPerformAction, Permission } from '../../../utils/permissions';

interface PermissionRouteProps {
  element: React.ReactElement;
  permission: Permission;
  deniedTo?: string;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  element,
  permission,
  deniedTo = '/access-denied',
}) => {
  const { accounts, inProgress } = useMsal();
  const { currentUser, isLoading } = useContext(AuthContext);

  if (
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Login ||
    inProgress === InteractionStatus.AcquireToken
  ) {
    return <Loading />;
  }

  // A partner iframe (MixVoIP) session has no MSAL account.
  if (accounts.length === 0 && !hasPartnerSession()) {
    return <Navigate to={getEmbedHomePath()} />;
  }

  if (isLoading || !currentUser) {
    return <Loading />;
  }

  return canPerformAction(currentUser, permission) ? (
    element
  ) : (
    <Navigate to={appendEmbedParam(deniedTo)} replace />
  );
};

export default PermissionRoute;
